"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Package Import
 */
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
/*
 * Local Import
 */
// Helpers
const routes_1 = require("src/constants/routes");
// Components
const Instances_1 = __importDefault(require("src/components/Instances"));
const Nav_1 = __importDefault(require("src/components/Nav"));
/*
 * Component
 */
const App = () => {
    return (react_1.default.createElement(react_router_dom_1.Switch, null,
        react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: routes_1.BASE_URL },
            react_1.default.createElement("div", { style: { display: 'flex', height: '100%' } },
                react_1.default.createElement(Nav_1.default, null),
                react_1.default.createElement(Instances_1.default, null))),
        react_1.default.createElement(react_router_dom_1.Route, { exact: true }, "404 Not Found")));
};
/*
 * Export
 */
exports.default = App;
